module.exports = __webpack_public_path__ + "media/images/card_backgrounds/doctor_degree-9e609ebd8a13b1b8d90c49dcd8d74493.png";